import { LoginPage } from "@/interface/pages/login-page";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const loginSearchParamsSchema = z.object({
  from: z.string().optional().catch(""),
});

export const Route = createFileRoute("/auth/login")({
  validateSearch: loginSearchParamsSchema,
  component: RouteComponent,
});

function RouteComponent() {
  return <LoginPage />;
}
